<template>
  <a-modal
    title="在线开票"
    v-model="visible"
    okText="保存"
    cancelText="关闭"
    :bodyStyle="{ minHeight: '300px' }"
    width="1300px"
    @ok="handleOk"
    :confirmLoading="loading"
  >
    <a-form :form="form">
      <!-- cvenpuomprotocol 收付款协议   
        cvenpuomprotocolname 收付款协议名称   
        icreditperiod 账期信息    
        dcreditstart 立账日    
        dgatheringdate  到期日 -->
      <a-form-item label v-show="false">
        <a-input v-decorator="['cpersoncode', { rules: [] }]" />
        <a-input v-decorator="['cdepcode', { rules: [] }]" />
        <a-input v-decorator="['cincode', { rules: [] }]" />
        <a-input v-decorator="['cunitcode', { rules: [] }]" />
        <a-input v-decorator="['cvencode', { rules: [] }]" />
        <a-input v-decorator="['cptcode', { rules: [] }]" />
        <!-- <a-input v-decorator="['idiscounttaxtype', { rules: [] }]" /> -->
        <a-input v-decorator="['purbilltype', { rules: [] }]" />

        <a-input v-decorator="['cvenpuomprotocol']" />
        <a-input v-decorator="['cvenpuomprotocolname']" />
        <a-input v-decorator="['icreditperiod']" />
        <a-date-picker v-decorator="['dcreditstart']" />
        <a-date-picker v-decorator="['dgatheringdate']" />
      </a-form-item>
      <a-row :gutter="24">
        <a-col :xs="24" :sm="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单据号" :required="iscpbvcode">
            <a-input
              v-if="iscpbvcode"
              placeholder="请输入"
              v-decorator="['cpbvcode', { rules: [{ message: '单据号不能为空', required: iscpbvcode }] }]"
            />
            <a-input v-else placeholder="单据号自动生成" v-decorator="['cpbvcode']" :disabled="true" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="业务类型">
            <a-input v-decorator="['cbustype']" :disabled="true" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发票类型">
            <a-select v-decorator="['cpbvbilltype']" @change="changeType">
              <a-select-option v-for="(item, index, key) in pbvbillTypeList" :value="item.id" :key="key">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :xs="24" :sm="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="扣税类别">
            <a-select v-decorator="['idiscounttaxtype']" :disabled="true">
              <a-select-option v-for="(item, index, key) in taxTypeList" :value="item.id" :key="key">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开票日期">
            <a-date-picker v-decorator="['dpbvdate', { rules: [{ type: 'object' }] }]" :disabled="true" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商">
            <a-input v-decorator="['cvenname']" :disabled="true" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :xs="24" :sm="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="代垫单位">
            <a-select v-decorator="['cunitcode']" :allowClear="true" placeholder="请选择">
              <a-select-option v-for="(item, index) in dwList" :key="index" :value="item.cvencode">{{ item.cvenname }}</a-select-option>
            </a-select>

            <!-- <a-input v-decorator="['cvenname']" /> -->
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购类型">
            <a-input v-decorator="['cptname']" :disabled="true" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="税率">
            <a-input v-decorator="['ipbvtaxrate']" :disabled="true" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :xs="24" :sm="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="部门名称">
            <a-input v-decorator="['cdepname']" :disabled="true" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="业务员">
            <a-input v-decorator="['cpersonname']" :disabled="true" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="币种">
            <a-input v-decorator="['cexch_name']" :disabled="true" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :xs="24" :sm="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="汇率">
            <a-input v-decorator="['cexchrate']" :disabled="true" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款条件">
            <a-input v-decorator="['cpaycode']" :disabled="true" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发票日期">
            <a-date-picker v-decorator="['dvoudate']" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :xs="24" :sm="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购发票号">
            <a-input v-decorator="['cordercode']" :disabled="true" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="制单人">
            <a-input v-decorator="['cpbvmaker']" :disabled="true" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
            <a-input v-decorator="['cpbvmemo']" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="16">
          <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="附件上传">
            <a-upload
              v-decorator="['fileIds']"
              :action="fileUpload"
              :fileList="fileList"
              :data="{ code: '#', type: 'kptzd' }"
              accept=".pdf,.jpg,.png"
              class="upload-list-inline"
              list-type="text"
              @change="handleUpload"
            >
              <!--  @preview="handlePreview" -->
              <a-button> <a-icon type="upload" /> upload </a-button>
              <span> 支持.pdf、.png、.jpg格式文件</span>
            </a-upload>
          </a-form-item>
          <!-- accept=".pdf" -->
        </a-col>
      </a-row>
    </a-form>
    <uto-table-new :columns="columns" :dataSource="dataSource" rowKey="autoid" bordered :pagination="false">
      <template slot="operation" slot-scope="text, record, index">
        <a-popconfirm title="确认删除?" @confirm="() => todeletevirtual(record)">
          <a>删除</a>
        </a-popconfirm>
        <a-divider type="vertical"></a-divider>
        <a @click="toCf(record, index)">拆分</a>
      </template>
      <template slot="ipbvquantityR" slot-scope="text, record, index">
        <a-input-number :min="1" style="margin: -5px 0" :value="text" :precision="precision" @change="e => handleChange(e, 'ipbvquantity', index)" />
      </template>
      <template slot="ioricostR" slot-scope="text, record, index">
        <a-input-number style="margin: -5px 0" :value="text" :precision="precision" @change="e => handleChange(e, 'ioricost', index)" :min="0" />
      </template>
    </uto-table-new>
  </a-modal>
</template>
<script>
import {
  scmApi,
  addPurDQRBillAndDetailInfo,
  getRdRecord01ByAutoId,
  queryPrice,
  getPUTVMIUsedVouchsByAutoId,
  getBillVoucherNumber,
  getVenHeadCode,
  deleteConsultFiles
} from '@/api/scmApi'
import moment from 'moment'
import { api, fileUpload } from '@/api/manage'
import { getStore, SPF } from '@/utils/storage'
export default {
  name: 'BillAddModule',
  data() {
    return {
      form: this.$form.createForm(this),
      visible: false,
      userinfo: this.$store.getters.userinfo,
      pbvbillTypeList: this.$store.getters.moduleEnums.scm.pbvbillType.data,
      vendorList: this.$store.getters.vendorEnums,
      labelCol: { xs: { span: 24 }, sm: { span: 8 } },
      wrapperCol: { xs: { span: 24 }, sm: { span: 16 } },

      labelCol2: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      dataSource: [],
      cacheData: [],
      iposid: '',
      bNegative: 0,
      taxTypeList: [
        {
          id: '0',
          text: '应税外加'
        },
        {
          id: '1',
          text: '应税内含'
        }
      ],
      columns: [
        {
          title: '操作',
          key: 'operation',
          scopedSlots: { customRender: 'operation' },
          width: 150
        },
        {
          title: '存货编码',
          dataIndex: 'cinvcode',
          width: 120
        },
        {
          title: '存货名称',
          dataIndex: 'cinvname',
          width: 150
        },
        {
          title: '规格型号',
          dataIndex: 'cinvstd',
          width: 150
        },
        {
          title: '单位名称',
          dataIndex: 'cinvm_unit',
          width: 100
        },
        {
          title: '开票数量',
          dataIndex: 'ipbvquantity',
          width: 140,
          scopedSlots: { customRender: 'ipbvquantityR' }
        },
        {
          title: '原币单价',
          dataIndex: 'ioricost',
          width: 140,
          scopedSlots: { customRender: 'ioricostR' }
        },
        {
          title: '原币金额',
          dataIndex: 'iorimoney',
          width: 130
        },
        {
          title: '原币税额',
          dataIndex: 'ioritaxprice',
          width: 130
        },
        {
          title: '原币含税单价',
          dataIndex: 'ioritaxcost',
          width: 130
        },
        {
          title: '原币价税合计',
          dataIndex: 'iorisum',
          width: 130
        },
        {
          title: '税率',
          dataIndex: 'itaxrate',
          width: 90
        },
        {
          title: '订单号',
          dataIndex: 'ccode',
          width: 150
        }
      ],
      formData: {},
      idiscounttaxtype: null,
      issaved: false,
      loading: false,
      precision: null,
      iscpbvcode: true,
      fileUpload: '',
      bfData: [],
      fileList: [],
      fileId: '',
      dwList: []
    }
  },
  created() {},
  mounted() {
    const res = getStore(SPF.API)
    this.fileUpload = (res ? '/' + res.substring(res.indexOf('@') + 1) : '') + api.fileUpload
    this.getPrecision()
  },
  methods: {
    moment,
    getVenHeadCode(data) {
      const that = this
      getVenHeadCode({ cVenCode: data.cvencode })
        .then(res => {
          if (res.code == 0 && res.data) {
            that.dwList = res.data
          } else {
            that.$message.error(res.msg ? res.msg : '数据加载失败')
          }
        })
        .catch()
    },
    // 删除图片
    handleUpload(e) {
      const that = this
      let fileList = [...e.fileList]
      fileList = fileList.slice(-1)
      this.fileList = fileList

      // if (e.file.status == 'removed') {
      //   this.$confirm({
      //     title: '是否确定删除?',
      //     onOk() {
      //       deleteConsultFiles({ id: that.baseRecord.id }).then(res => {
      //         if (res.code == 0) {
      //           that.$message.success('删除成功！')
      //           that.fileList = []
      //         } else {
      //           that.$message.error(res.msg ? res.msg : '删除失败')
      //         }
      //       })
      //     },
      //     onCancel() {
      //       that.fileList = fileList
      //     }
      //   })
      // }
      const response = this.fileList.length && this.fileList[0]['response'] ? this.fileList[0]['response'] : null
      if (response) {
        this.fileId = response.data[0].id
      }
      // const files = this.fileList.map(file => {
      //   if (file.response) {
      //     file.id = file.response.data[0].id
      //     return file.id
      //   }
      // })
      // this.fileId = files.join()
    },

    toCf(record, index) {
      const newD = [...this.dataSource]
      const data = { ...newD[index] } //复制当前行的所有数据
      newD.splice(index + 1, 0, data)
      this.dataSource = newD
      console.log('newData', this.dataSource)
    },
    getPrecision() {
      // 精度是从获取的
      queryPrice()
        .then(res => {
          this.precision = Number(res.data[0].precision)
        })
        .catch()
    },
    changeType(val) {
      const that = this
      if (String(val) === '01') {
        that.$nextTick(
          that.form.setFieldsValue({
            idiscounttaxtype: '0'
          })
        )
        that.idiscounttaxtype = '01'
        this.dataSource.map((item, index) => {
          this.handleChange(item.ipbvquantity, 'ipbvquantity', index)
        })
      } else if (String(val) === '02') {
        that.$nextTick(
          that.form.setFieldsValue({
            idiscounttaxtype: '1'
          })
        )
        that.idiscounttaxtype = '02'
        this.dataSource.map((item, index) => {
          this.handleChange(item.ipbvquantity, 'ipbvquantity', index)
        })
      }
    },
    getBillVoucherNumber() {
      const that = this
      getBillVoucherNumber()
        .then(res => {
          if (res.code == 0 && res.data) {
            // "ballowhandwork": false,：不开启手工编码
            //"ballowhandwork": true,：开启手工编码
            that.iscpbvcode = res.data.ballowhandwork
          } else {
            that.$message.error(res.msg ? res.msg : '数据加载失败')
          }
        })
        .catch()
    },
    toAdd(data) {
      //开票通知单
      const that = this
      this.getBillVoucherNumber()
      this.getVenHeadCode(data[0])
      that.dataSource = []
      that.visible = true
      that.issaved = false
      that.loadMainForm(data[0])
      if (data[0].idiscounttaxtype === 0) {
        that.idiscounttaxtype = '01'
      } else {
        that.idiscounttaxtype = '02'
      }
      data.map(curr => {
        curr.ipbvquantity = curr.inobillquantity
        if (curr.ipbvquantity < 0) {
          that.bNegative = 1
        }
      })
      this.dataSource = data
      this.bfData = JSON.parse(JSON.stringify(data))
      this.dataSource.map((item, index) => {
        this.initialChange(item.ipbvquantity, 'ipbvquantity', index)
      })
      console.log('带过来的值', this.dataSource)
    },
    toDggztzd(data) {
      // 待管挂账通知单
      const that = this
      that.dataSource = []
      that.visible = true
      that.issaved = false

      that.loadMainForm2(data[0])
      if (data[0].idiscounttaxtype === 0) {
        that.idiscounttaxtype = '01'
      } else {
        that.idiscounttaxtype = '02'
      }
      // data.map(curr => {
      //   curr.ipbvquantity = curr.inobillquantity
      //   if (curr.ipbvquantity < 0) {
      //     that.bNegative = 1
      //   }
      // })
      this.dataSource = JSON.parse(JSON.stringify(data))
      this.dataSource.map((item, index) => {
        this.initialChange(item.ipbvquantity, 'ipbvquantity', index)
      })
    },
    loadMainForm(formData) {
      const _that = this
      _that.form.resetFields()
      getRdRecord01ByAutoId({ autoid: formData.autoid })
        .then(res => {
          if (res.code === 0 || res.code === '0') {
            _that.$nextTick(() => {
              _that.form.setFieldsValue({
                //隐藏有12个值，显示的有18个值共30个
                cincode: formData.ccode,
                cvencode: formData.cvencode,
                cvenname: formData.cvenname,
                cbustype: res.data.cbustype,
                cpbvbilltype: String(_that.idiscounttaxtype), //接口中没有这个字段cpbvbilltype，只能通过idiscounttaxtype去判断
                dpbvdate: _that.string2date(_that.date2string(new Date())),
                cunitcode: formData.cvencode,
                cptcode: formData.cptcode,
                cptname: formData.cptname,
                ipbvtaxrate: formData.itaxrate,
                cdepcode: formData.cdepcode,
                cdepname: formData.cdepname,
                cpersoncode: formData.cpersoncode,
                cpersonname: formData.cpersonname,
                cexch_name: formData.cexch_name,
                cexchrate: res.data.iexchrate,
                cpaycode: formData.cpaycode,
                cpbvcode: formData.cpbvcode,
                cpbvmaker: _that.userinfo.username,
                idiscounttaxtype: String(res.data.idiscounttaxtype),
                purbilltype: formData.purbilltype ? formData.purbilltype : '',
                iinvexchrate: formData.iinvexchrate ? formData.iinvexchrate : '',
                cvenpuomprotocol: formData.cvenpuomprotocol ? formData.cvenpuomprotocol : '',
                cvenpuomprotocolname: formData.cvenpuomprotocolname ? formData.cvenpuomprotocolname : '',
                icreditperiod: formData.icreditperiod ? formData.icreditperiod : null,
                dcreditstart: formData.dcreditstart ? moment(formData.dcreditstart) : null,
                dgatheringdate: formData.dgatheringdate ? moment(formData.dgatheringdate) : null,
                dvoudate: formData.dvoudate ? moment(formData.dvoudate) : null
              })
            })
            this.iposid = res.data.iposid ? res.data.iposid : ''
          } else {
            _that.$message.error(res.msg)
          }
        })
        .catch(function() {
          _that.$message.error('获取采购入库信息失败!')
        })
    },
    loadMainForm2(formData) {
      // 代管挂账通知单
      const _that = this
      _that.form.resetFields()
      getPUTVMIUsedVouchsByAutoId({ autoid: formData.autoid })
        .then(res => {
          if (res.code === 0 || res.code === '0') {
            _that.$nextTick(() => {
              _that.form.setFieldsValue({
                //隐藏有12个值，显示的有18个值共30个
                cincode: formData.ccode,
                cvencode: formData.cvencode,
                cvenname: formData.cvenname,
                cbustype: res.data.cbustype,
                cpbvbilltype: String(_that.idiscounttaxtype), //接口中没有这个字段cpbvbilltype，只能通过idiscounttaxtype去判断
                dpbvdate: _that.string2date(_that.date2string(new Date())),
                cunitcode: formData.cvencode,
                cptcode: formData.cptcode,
                cptname: formData.cptname,
                ipbvtaxrate: formData.itaxrate,
                cdepcode: formData.cdepcode,
                cdepname: formData.cdepname,
                cpersoncode: formData.cpersoncode,
                cpersonname: formData.cpersonname,
                cexch_name: formData.cexch_name,
                cexchrate: res.data.iexchrate,
                cpaycode: formData.cpaycode, //无
                cpbvcode: formData.cpbvcode, //无
                cpbvmaker: _that.userinfo.username,
                idiscounttaxtype: String(res.data.idiscounttaxtype),
                purbilltype: formData.purbilltype ? formData.purbilltype : '',
                iinvexchrate: formData.iinvexchrate ? formData.iinvexchrate : '',
                cvenpuomprotocol: formData.cvenpuomprotocol ? formData.cvenpuomprotocol : '',
                cvenpuomprotocolname: formData.cvenpuomprotocolname ? formData.cvenpuomprotocolname : '',
                icreditperiod: formData.icreditperiod ? formData.icreditperiod : null,
                dcreditstart: formData.dcreditstart ? moment(formData.dcreditstart) : null,
                dgatheringdate: formData.dgatheringdate ? moment(formData.dgatheringdate) : null,
                dvoudate: formData.dvoudate ? moment(formData.dvoudate) : null //无
              })
            })
            this.iposid = res.data.iposid ? res.data.iposid : ''
          } else {
            _that.$message.error(res.msg)
          }
        })
        .catch(function() {
          _that.$message.error('获取采购入库信息失败!')
        })
    },
    date2string(df) {
      if (df) {
        return moment(df).format('YYYY-MM-DD')
      } else {
        return null
      }
    },
    string2date(df) {
      if (df) {
        return moment(df)
      } else {
        return undefined
      }
    },
    todeletevirtual(record) {
      const newData = [...this.dataSource]
      const target = newData.filter(item => record.autoid !== item.autoid)
      if (target) {
        this.dataSource = target
        this.cacheData = target.map(item => ({ ...item }))
      }
    },
    keepTwo(num) {
      var result = parseFloat(num)
      if (isNaN(result)) {
        return 0
      }
      result = Math.round(num * 100) / 100
      var s_x = result.toString()
      var pos_decimal = s_x.indexOf('.')
      if (pos_decimal < 0) {
        pos_decimal = s_x.length
        s_x += '.'
      }
      while (s_x.length <= pos_decimal + 2) {
        s_x += '0'
      }
      return s_x
    },
    handleChange(value, column, index) {
      //2021年计算规则
      // cPBVBillType-发票类型：01-专用发票，02-普通发票
      // iDiscountTaxType-扣税类别：0-应税外加；1-应税内含
      // 不同扣税类别下无税单价、金额与含税单价、金额的计算规则：
      // 应税外加：原币税额=无税金额（原币单价*数量）*税率%；价税合计=无税金额（原币单价*数量）*（1+税率）
      // 应税外加:原币含税单价=原币单价*（1+税率%); 原币单价=原币含税单价/(1+税率）
      // 应税内含：原币税额=价税合计（原币含税单价*数量）*税率%；无税金额（原币金额）=价税合计（原币含税单价*数量）*（1-税率）；
      // 应税内含：原币含税单价=原币单价/（1-税率）;原币单价=原币含税单价*（1-税率%）

      // 采购专用发票只支持应税外加，普通发票只支持应税内含，运费发票只支持应税内含。
      // 采购专用发票在参照采购订单、采购入库单生单时，可参照扣税类别为"应税外加"的单据。
      // 采购普通发票在参照采购订单、采购入库单生单时，可参照扣税类＝"应税内含"或扣税类别＝"应税外加"的采购入库单、代管挂账确认单、采购订单记录。
      const _that = this
      const newData = [...this.dataSource]
      //ipbvquantity开票数量,itaxrate税率,ioricost原币单价,ioritaxcost原币含税单价
      if (column === 'ipbvquantity') {
        newData[index]['ipbvquantity'] = value
        if (value > 0) {
          // _that.bNegative = 0
          if (value > newData[index]['inobillquantity']) {
            _that.$message.warning('开票数量不能大于可开票数量，请重新输入!')
            value = newData[index]['inobillquantity']
          } else {
            // 应税外加：原币税额=无税金额（原币单价*数量）*税率%；价税合计=无税金额（原币单价*数量）*（1+税率）
            // 应税外加:原币含税单价=原币单价*（1+税率%); 原币单价=原币含税单价/(1+税率）
            // 应税内含：原币税额=价税合计（原币含税单价*数量）*税率%；无税金额（原币金额）=价税合计（原币含税单价*数量）*（1-税率）；
            // 应税内含：原币含税单价=原币单价/（1-税率）;原币单价=原币含税单价*（1-税率%）
            //原币金额 iorimoney
            //原币税额 ioritaxprice
            //原币含税单价 ioritaxcost
            //原币价税合计 iorisum
            if (String(_that.idiscounttaxtype) === '01') {
              //应税外加
              newData[index]['ioritaxcost'] = (newData[index]['ioricost'] * (1 + newData[index]['itaxrate'] / 100)).toFixed(_that.precision) //原币含税单价
              newData[index]['iorimoney'] = _that.keepTwo(value * newData[index]['ioricost']) //原币金额
              // newData[index]['iorisum'] = _that.keepTwo(value * newData[index]['ioritaxcost'] * (1 + newData[index]['itaxrate'] / 100)) //原币价税合计
              newData[index]['ioritaxprice'] = _that.keepTwo(value * newData[index]['ioricost'] * (newData[index]['itaxrate'] / 100)) //原币税额
              newData[index]['iorisum'] = _that.keepTwo(Number(newData[index]['iorimoney']) + Number(newData[index]['ioritaxprice']))
            } else {
              //应税内含
              newData[index]['ioritaxcost'] = (newData[index]['ioricost'] / (1 - newData[index]['itaxrate'] / 100)).toFixed(_that.precision) //原币含税单价
              newData[index]['iorimoney'] = _that.keepTwo(newData[index]['ioritaxcost'] * value * (1 - newData[index]['itaxrate'] / 100)) //原币金额
              // newData[index]['iorisum'] = _that.keepTwo(newData[index]['ioritaxcost'] * newData[index]['ipbvquantity']) //原币价税合计
              newData[index]['ioritaxprice'] = _that.keepTwo(newData[index]['ioritaxcost'] * value * (newData[index]['itaxrate'] / 100)) //原币税额
              newData[index]['iorisum'] = _that.keepTwo(Number(newData[index]['iorimoney']) + Number(newData[index]['ioritaxprice'])) //原币价税合计
            }
          }
        } else if (value < 0) {
          //负数时也要判断是专票还是普票
          // _that.bNegative = 1
          if (value < newData[index]['inobillquantity']) {
            _that.$message.warning('开票数量不能小于可开票数量，请重新输入!')
            value = newData[index]['inobillquantity']
          } else {
            //原币单价 ioricost
            //原币金额 iorimoney 对
            //原币税额 ioritaxprice
            //原币含税单价 ioritaxcost (取U8中的数值)
            //原币价税合计 iorisum
            if (String(_that.idiscounttaxtype) === '01') {
              //应税外加
              newData[index]['iorimoney'] = _that.keepTwo(value * newData[index]['ioricost']) //原币金额
              newData[index]['ioritaxprice'] = _that.keepTwo(value * newData[index]['ioricost'] * (newData[index]['itaxrate'] / 100)) //原币税额
              newData[index]['ioritaxcost'] = (newData[index]['ioricost'] * (1 + newData[index]['itaxrate'] / 100)).toFixed(_that.precision) //原币含税单价
              newData[index]['iorisum'] = _that.keepTwo(Number(newData[index]['iorimoney']) + Number(newData[index]['ioritaxprice'])) //原币价税合计
            } else {
              //应税内含

              newData[index]['iorimoney'] = _that.keepTwo(newData[index]['ioritaxcost'] * value * (1 - newData[index]['itaxrate'] / 100)) //原币金额
              newData[index]['ioritaxprice'] = _that.keepTwo(newData[index]['ioritaxcost'] * value * (newData[index]['itaxrate'] / 100)) //原币税额

              newData[index]['ioritaxcost'] = (newData[index]['ioricost'] / (1 - newData[index]['itaxrate'] / 100)).toFixed(_that.precision) //原币含税单价
              newData[index]['iorisum'] = _that.keepTwo(Number(newData[index]['iorimoney']) + Number(newData[index]['ioritaxprice'])) //原币价税合计
            }
          }
        } else {
          _that.$message.warning('开票数量不能为0!')
          value = newData[index]['inobillquantity']
        }
      }
      //ioricost原币单价
      if (column === 'ioricost') {
        newData[index]['ioricost'] = value // 原币单价也叫无税金额
        if (value) {
          // 应税外加：原币税额=无税金额（原币单价*数量）*税率%；价税合计=无税金额（原币单价*数量）*（1+税率）
          // 应税外加:原币含税单价=原币单价*（1+税率%); 原币单价=原币含税单价/(1+税率）
          // 应税内含：原币税额=价税合计（原币含税单价*数量）*税率%；无税金额（原币金额）=价税合计（原币含税单价*数量）*（1-税率）；
          // 应税内含：原币含税单价=原币单价/（1-税率）;原币单价=原币含税单价*（1-税率%）
          if (_that.idiscounttaxtype == '01') {
            //应税外加
            newData[index]['ioritaxcost'] = (value * (1 + newData[index]['itaxrate'] / 100)).toFixed(_that.precision) //原币含税单价
            newData[index]['iorimoney'] = _that.keepTwo(value * newData[index]['ipbvquantity']) //原币金额
            // newData[index]['iorisum'] = _that.keepTwo(value * newData[index]['ipbvquantity'] * (1 + newData[index]['itaxrate'] / 100)) //原币价税合计
            newData[index]['ioritaxprice'] = _that.keepTwo(value * newData[index]['ipbvquantity'] * (newData[index]['itaxrate'] / 100)) //原币税额
            newData[index]['iorisum'] = _that.keepTwo(Number(newData[index]['iorimoney']) + Number(newData[index]['ioritaxprice']))
          } else {
            //应税内含
            newData[index]['ioritaxcost'] = (value / (1 - newData[index]['itaxrate'] / 100)).toFixed(_that.precision) //原币含税单价
            newData[index]['iorimoney'] = _that.keepTwo(
              newData[index]['ioritaxcost'] * newData[index]['ipbvquantity'] * (1 - newData[index]['itaxrate'] / 100)
            ) //原币金额

            // newData[index]['iorisum'] = _that.keepTwo(newData[index]['ioritaxcost'] * newData[index]['ipbvquantity']) //原币价税合计
            newData[index]['ioritaxprice'] = _that.keepTwo(
              newData[index]['ioritaxcost'] * newData[index]['ipbvquantity'] * (newData[index]['itaxrate'] / 100)
            ) //原币税额
            newData[index]['iorisum'] = _that.keepTwo(Number(newData[index]['iorimoney']) + Number(newData[index]['ioritaxprice'])) //原币价税合计
          }
        } else {
          _that.$message.warning('原币单价不能为空或0!')
          value = 1
        }
      } else {
        newData[index][column] = value
      }
      _that.dataSource = newData
    },
    //加载初始的时候，原币含税单价要取U8传过来的数值
    initialChange(value, column, index) {
      //2021年计算规则
      // cPBVBillType-发票类型：01-专用发票，02-普通发票
      // iDiscountTaxType-扣税类别：0-应税外加；1-应税内含
      // 不同扣税类别下无税单价、金额与含税单价、金额的计算规则：
      // 应税外加：原币税额=无税金额（原币单价*数量）*税率%；价税合计=无税金额（原币单价*数量）*（1+税率）
      // 应税外加:原币含税单价=原币单价*（1+税率%); 原币单价=原币含税单价/(1+税率）
      // 应税内含：原币税额=价税合计（原币含税单价*数量）*税率%；无税金额（原币金额）=价税合计（原币含税单价*数量）*（1-税率）；
      // 应税内含：原币含税单价=原币单价/（1-税率）;原币单价=原币含税单价*（1-税率%）

      // 采购专用发票只支持应税外加，普通发票只支持应税内含，运费发票只支持应税内含。
      // 采购专用发票在参照采购订单、采购入库单生单时，可参照扣税类别为"应税外加"的单据。
      // 采购普通发票在参照采购订单、采购入库单生单时，可参照扣税类＝"应税内含"或扣税类别＝"应税外加"的采购入库单、代管挂账确认单、采购订单记录。
      const _that = this
      const newData = [...this.dataSource]
      //ipbvquantity开票数量,itaxrate税率,ioricost原币单价,ioritaxcost原币含税单价
      if (column === 'ipbvquantity') {
        newData[index]['ipbvquantity'] = value
        if (value > 0) {
          // _that.bNegative = 0
          if (value > newData[index]['inobillquantity']) {
            _that.$message.warning('开票数量不能大于可开票数量，请重新输入!')
            value = newData[index]['inobillquantity']
          } else {
            // 应税外加：原币税额=无税金额（原币单价*数量）*税率%；价税合计=无税金额（原币单价*数量）*（1+税率）
            // 应税外加:原币含税单价=原币单价*（1+税率%); 原币单价=原币含税单价/(1+税率）
            // 应税内含：原币税额=价税合计（原币含税单价*数量）*税率%；无税金额（原币金额）=价税合计（原币含税单价*数量）*（1-税率）；
            // 应税内含：原币含税单价=原币单价/（1-税率）;原币单价=原币含税单价*（1-税率%）
            if (String(_that.idiscounttaxtype) === '01') {
              //应税外加
              newData[index]['iorimoney'] = _that.keepTwo(value * newData[index]['ioricost']) //原币金额
              newData[index]['ioritaxprice'] = _that.keepTwo(value * newData[index]['ioricost'] * (newData[index]['itaxrate'] / 100)) //原币税额
              newData[index]['iorisum'] = _that.keepTwo(Number(newData[index]['iorimoney']) + Number(newData[index]['ioritaxprice']))
            } else {
              //应税内含
              newData[index]['iorimoney'] = _that.keepTwo(newData[index]['ioritaxcost'] * value * (1 - newData[index]['itaxrate'] / 100)) //原币金额
              newData[index]['ioritaxprice'] = _that.keepTwo(newData[index]['ioritaxcost'] * value * (newData[index]['itaxrate'] / 100)) //原币税额
              newData[index]['iorisum'] = _that.keepTwo(Number(newData[index]['iorimoney']) + Number(newData[index]['ioritaxprice'])) //原币价税合计
            }
          }
        } else if (value < 0) {
          //负数时也要判断是专票还是普票
          // _that.bNegative = 1
          if (value < newData[index]['inobillquantity']) {
            _that.$message.warning('开票数量不能小于可开票数量，请重新输入!')
            value = newData[index]['inobillquantity']
          } else {
            if (String(_that.idiscounttaxtype) === '01') {
              //应税外加
              newData[index]['iorimoney'] = _that.keepTwo(value * newData[index]['ioricost']) //原币金额
              newData[index]['ioritaxprice'] = _that.keepTwo(value * newData[index]['ioricost'] * (newData[index]['itaxrate'] / 100)) //原币税额
              newData[index]['iorisum'] = _that.keepTwo(Number(newData[index]['iorimoney']) + Number(newData[index]['ioritaxprice']))
            } else {
              //应税内含
              newData[index]['iorimoney'] = _that.keepTwo(newData[index]['ioritaxcost'] * value * (1 - newData[index]['itaxrate'] / 100)) //原币金额
              newData[index]['ioritaxprice'] = _that.keepTwo(newData[index]['ioritaxcost'] * value * (newData[index]['itaxrate'] / 100)) //原币税额
              newData[index]['iorisum'] = _that.keepTwo(Number(newData[index]['iorimoney']) + Number(newData[index]['ioritaxprice'])) //原币价税合计
            }
          }
        } else {
          _that.$message.warning('开票数量不能为0!')
          value = newData[index]['inobillquantity']
        }
      }
      //ioricost原币单价
      if (column === 'ioricost') {
        newData[index]['ioricost'] = value // 原币单价也叫无税金额
        if (value) {
          // 应税外加：原币税额=无税金额（原币单价*数量）*税率%；价税合计=无税金额（原币单价*数量）*（1+税率）
          // 应税外加:原币含税单价=原币单价*（1+税率%); 原币单价=原币含税单价/(1+税率）
          // 应税内含：原币税额=价税合计（原币含税单价*数量）*税率%；无税金额（原币金额）=价税合计（原币含税单价*数量）*（1-税率）；
          // 应税内含：原币含税单价=原币单价/（1-税率）;原币单价=原币含税单价*（1-税率%）
          if (_that.idiscounttaxtype == '01') {
            //应税外加
            newData[index]['iorimoney'] = _that.keepTwo(value * newData[index]['ipbvquantity']) //原币金额
            // newData[index]['iorisum'] = _that.keepTwo(value * newData[index]['ipbvquantity'] * (1 + newData[index]['itaxrate'] / 100)) //原币价税合计
            newData[index]['ioritaxprice'] = _that.keepTwo(value * newData[index]['ipbvquantity'] * (newData[index]['itaxrate'] / 100)) //原币税额
            newData[index]['iorisum'] = _that.keepTwo(Number(newData[index]['iorimoney']) + Number(newData[index]['ioritaxprice']))
          } else {
            //应税内含
            newData[index]['iorimoney'] = _that.keepTwo(
              newData[index]['ioritaxcost'] * newData[index]['ipbvquantity'] * (1 - newData[index]['itaxrate'] / 100)
            ) //原币金额
            newData[index]['ioritaxprice'] = _that.keepTwo(
              newData[index]['ioritaxcost'] * newData[index]['ipbvquantity'] * (newData[index]['itaxrate'] / 100)
            ) //原币税额
            newData[index]['iorisum'] = _that.keepTwo(Number(newData[index]['iorimoney']) + Number(newData[index]['ioritaxprice'])) //原币价税合计
          }
        } else {
          _that.$message.warning('原币单价不能为空或0!')
          value = 1
        }
      } else {
        newData[index][column] = value
      }
      _that.dataSource = newData
    },
    handleOk() {
      const _that = this
      if (_that.issaved) {
        _that.$message.warning('该单据已经保存请勿多次提交!')
      } else {
        _that.form.validateFields((err, values) => {
          if (!err) {
            if (_that.dataSource.length > 0) {
              // 拆分后的开票数量不能超过可开票数量
              const flag = _that.bfData.some(item => {
                const arr = _that.dataSource.filter(item2 => item.autoid == item2.autoid)
                let kpzh = arr.reduce((sum, item3) => {
                  return sum + item3.ipbvquantity
                }, 0)
                return kpzh > item.ipbvquantity
              })
              if (flag) {
                _that.$message.error('拆分后的开票数量不能超过可开票数量')
                return
              }
              const qtytotal = _that.dataSource.reduce((sum, item) => {
                return sum + item.ipbvquantity
              }, 0)
              const jgtotal = _that.dataSource.reduce((sum, item) => {
                return sum + Number(item.iorisum)
              }, 0)
              if (qtytotal >= 0 && jgtotal > 0) {
                // 开票数量为正且金额>0 开蓝字
                _that.bNegative = 0
              } else if (qtytotal <= 0 && jgtotal < 0) {
                // 开票数量为负且金额<0 开红字
                _that.bNegative = 1
              } else if (qtytotal == 0 && jgtotal == 0) {
                _that.$message.error('开票不成功，请检查数量合计及金额合计！')
                return
              } else {
                _that.$message.error('开票不成功，请检查数量合计及金额合计！')
                return
              }
              const detail = JSON.parse(JSON.stringify(_that.dataSource))
              values['details'] = JSON.stringify(detail)
              values['dvoudate'] = _that.date2string(values['dvoudate'])
              values['dpbvdate'] = _that.date2string(values['dpbvdate'])
              values['dcreditstart'] = _that.date2string(values['dcreditstart'])
              values['dgatheringdate'] = _that.date2string(values['dgatheringdate'])
              values['bNegative'] = _that.bNegative
              values['iposid'] = _that.iposid
              values['fileIds'] = _that.fileId
              _that.loading = true
              console.log('参数', values['fileIds'], values['cunitcode'])
              debugger
              addPurDQRBillAndDetailInfo(values)
                .then(res => {
                  if (res.code === 0 || res.code === '0') {
                    _that.form.setFieldsValue({
                      cpbvcode: res.cpbvcode
                    })
                    _that.$message.success('保存成功')

                    _that.loading = false
                    _that.visible = false
                    _that.$emit('success')
                    // _that.issaved = true
                  } else {
                    _that.loading = false
                    _that.$message.error(res.msg)
                  }
                })
                .catch(function() {
                  _that.loading = false
                  _that.$message.error('新增失败!')
                })
            } else {
              _that.$message.warning('请选择填写表体数据信息！')
            }
          }
        })
      }
    }
  }
}
</script>
